import api from '../config/api'
import IAuthData from '../types/Auths'
import secureLocalStorage from 'react-secure-storage'

const login = (data: any) => {
  return api.post<IAuthData>('/login', data)
}

const logout = () => {
  secureLocalStorage.setItem('impersonate_mode', 'false');
  return api.post<IAuthData>('/logout')
}

const version = () => {
  return api.get('/version')
}

const forgotPassword = (data: any) => {
  return api.post('/forgot-password', data)
}

const resetPassword = (data: any) => {
  return api.post('/reset-password', data)
}

const saveSession = (data: any) => {
  secureLocalStorage.removeItem('dt_start_session')
  secureLocalStorage.setItem('token', data.access_token)
  secureLocalStorage.setItem('permissions', data.permissions.join(','))
  secureLocalStorage.setItem('name', data.profile.name)
  secureLocalStorage.setItem('entity', data.profile.entity_id)
  secureLocalStorage.setItem('id', data.profile.id)
  secureLocalStorage.setItem('role', data.role[0])
  secureLocalStorage.setItem('avatar_url', data.profile.avatar)
  secureLocalStorage.setItem('expires_in', data.expires_in)
  secureLocalStorage.setItem('dt_start_session', new Date())
  localStorage.setItem('menu', '1')
}

const LoginService = {
  login,
  logout,
  version,
  forgotPassword,
  resetPassword,
  saveSession,
}

export default LoginService
